export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
            关于69视频
          </h2>
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              69视频成立于2024年，是一个专注于特色视频网站导航与资源聚合的综合平台。
              我们致力于为广大视频爱好者提供一站式的视频内容发现体验，
              汇集丝瓜视频、蓝莓视频、糖心视频、黑桃视频、妖精视频、桃花视频等众多优质视频站点。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台涵盖电影、电视剧、综艺、动漫、纪录片等多种内容类型，
              每日持续更新海量高清视频资源，所有内容均可免费在线观看。
              我们采用多线路智能切换技术，确保流畅不缓冲的播放体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              69视频始终坚持为用户筛选优质的特色视频内容，
              同时为优质视频站点提供展示与推广的窗口。
              我们的目标是成为连接用户与优质视频内容之间的桥梁，
              让每个人都能轻松找到并享受自己喜欢的视频内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}